import { getBrandLogoSrc } from 'utils/brandLogo';

import {
  FALLBACK_BACKGROUND_COLOR,
  POWERED_BY_BRAND,
  POWERED_BY_PREFIX,
  UNLOCK_SCREEN_ELEMENT_ID,
  UNLOCK_SCREEN_STYLE_ID,
  UNLOCK_SCREEN_SUBTITLE,
  UNLOCK_SCREEN_TITLE,
} from './unlockScreen.constants';

const ID = UNLOCK_SCREEN_ELEMENT_ID;

// Per-tenant brand is inlined at build time (DEV-3717) — read lazily so the value
// is whatever the boot contract seeded, with a Lender fallback. Read here rather
// than at module scope because nativeBoot runs before the bundle's other modules.
const getBackgroundColor = () => window.lsBrandSplashColor || FALLBACK_BACKGROUND_COLOR;

// Full-screen branded overlay shown behind the OS biometric dialog (which always
// renders centered and opaque) — logo frames it above, copy below, a persistent
// "Powered by Lender" co-brand mark at the bottom. Injected straight into the DOM
// because nativeBoot runs before React mounts.
const buildStyles = backgroundColor => `
#${ID}{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;text-align:center;
background:radial-gradient(120% 78% at 50% 34%,rgba(255,255,255,.07),rgba(255,255,255,0) 58%),${backgroundColor};
font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;
padding:calc(env(safe-area-inset-top) + 24px) 24px calc(env(safe-area-inset-bottom) + 24px);
animation:ls-fade .45s ease both;}
@keyframes ls-fade{from{opacity:0}to{opacity:1}}
#${ID} .ls-logo{position:absolute;top:27%;max-width:160px;max-height:56px;animation:ls-rise .5s ease both}
@keyframes ls-rise{from{opacity:0;transform:translateY(10px)}to{opacity:.95;transform:none}}
#${ID} .ls-copy{position:absolute;left:24px;right:24px;bottom:25%}
#${ID} .ls-title{color:#fff;font-size:21px;font-weight:600;letter-spacing:-.01em}
#${ID} .ls-sub{color:#9aa3b2;font-size:14.5px;margin-top:8px}
#${ID} .ls-dots{display:flex;gap:6px;justify-content:center;margin-top:18px}
#${ID} .ls-dots i{width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,.55);animation:ls-dot 1.2s ease-in-out infinite}
#${ID} .ls-dots i:nth-child(2){animation-delay:.18s}
#${ID} .ls-dots i:nth-child(3){animation-delay:.36s}
@keyframes ls-dot{0%,100%{opacity:.25;transform:scale(.82)}50%{opacity:1;transform:scale(1)}}
#${ID} .ls-powered{position:absolute;left:0;right:0;bottom:calc(env(safe-area-inset-bottom) + 22px);color:#7e8696;font-size:11.5px;letter-spacing:.02em}
#${ID} .ls-powered b{color:#aeb6c4;font-weight:600}
`;

const buildMarkup = logoSrc =>
  `<img class="ls-logo" src="${logoSrc}" alt="" />` +
  `<div class="ls-copy">` +
  `<div class="ls-title">${UNLOCK_SCREEN_TITLE}</div>` +
  `<div class="ls-sub">${UNLOCK_SCREEN_SUBTITLE}</div>` +
  `<div class="ls-dots"><i></i><i></i><i></i></div>` +
  `</div>` +
  `<div class="ls-powered">${POWERED_BY_PREFIX} <b>${POWERED_BY_BRAND}</b></div>`;

export const showUnlockScreen = () => {
  if (typeof document === 'undefined' || document.getElementById(ID)) {
    return;
  }

  const style = document.createElement('style');
  style.id = UNLOCK_SCREEN_STYLE_ID;
  style.textContent = buildStyles(getBackgroundColor());
  document.head.appendChild(style);

  const overlay = document.createElement('div');
  overlay.id = ID;
  overlay.innerHTML = buildMarkup(getBrandLogoSrc());
  document.body.appendChild(overlay);
};

export const hideUnlockScreen = () => {
  if (typeof document === 'undefined') {
    return;
  }

  document.getElementById(ID)?.remove();
  document.getElementById(UNLOCK_SCREEN_STYLE_ID)?.remove();
};
